<p-toast
  class="toast"
  position="bottom-center"
  [life]="config.life_time"
>
  <ng-template
    #message
    let-message
  >
    <div class="toast__content">
      <app-icon
        [icon]="message.severity === 'success' ? 'CircleTickMajor' : 'AlertMinor'"
        [width]="20"
      />

      <div class="toast__message">
        {{ message.detail }}
      </div>
    </div>
  </ng-template>
</p-toast>
